import { useState } from 'react';
import './CardPage.css';
import { resources } from '../../utils/resources';
import { useUI } from '../../hooks/useUI';
import Navigation from '../Navigation/Navigation';
import ModalWindow from '../ModalWindow/ModalWindow';
import Deposit from '../Deposit/Deposit';
import Transfer from '../Transfer/Transfer';
import CustomAlert from '../CustomAlert/CustomAlert';

const CardPage = (props) => {
    const [modalTitle, setModalTitle] = useState('');
    const [modalContent, setModalContent] = useState('');
    const [isCardNumberVisible, setIsCardNumberVisible] = useState(false);
    const [isFlipped, setIsFlipped] = useState(false);

    const [alertText, setAlertText] = useState('');
    const [alertKey, setAlertKey] = useState(0);

    const { openModal, userData } = useUI();

    function openDepModal() {
        setModalContent('dep');
        setModalTitle('Deposit');
        openModal();
    }

    function openTransferModal() {
        setModalContent('transfer');
        setModalTitle('Transfer');
        openModal();
    }

    function formatNumber(num) {
        if (num >= 1_000_000) {
            return (num / 1_000_000).toFixed(2).replace('.', ',') + 'М';
        }

        if (Number.isInteger(num)) {
            return num.toLocaleString('en');
        } else {
            return num.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
    }

    function formatCardNumber(cardNumber) {
        if (!cardNumber) return '**** **** **** ****';
        const cardNumberStr = String(cardNumber);

        if (isCardNumberVisible) {
            return cardNumberStr.match(/.{1,4}/g)?.join(' ') || cardNumberStr;
        } else {
            const lastFour = cardNumberStr.slice(-4);
            return `**** **** **** ${lastFour}`;
        }
    }

    function formatCardDate(date) {
        if (!date) return '--/--';

        const dateStr = String(date).padStart(4, '0');
        const month = dateStr.slice(0, 2);
        const year = dateStr.slice(2, 4);
        return `${month}/${year}`;
    }

    const toggleCardNumberVisibility = () => {
        setIsCardNumberVisible((prev) => !prev);
    };

    const handleCardFlip = () => {
        setIsFlipped((prev) => !prev);
    };

    const copyCardNum = async () => {
        await navigator.clipboard.writeText(userData.user_card_number);
        setIsFlipped((prev) => !prev);
        setAlertText('Copied!');
        setAlertKey((prev) => prev + 1);
    }


    return (
        <div className='cardPage' style={{ backgroundImage: `url(${resources.images.bgLight})` }}>
            <CustomAlert key={alertKey} text={alertText} />
            <div className="container">
                <div className='cardPage__title appearanceAnimation'>Card</div>
                <div className="cardPage__cardViewWrp" onClick={handleCardFlip}>
                    <div className={`cardPage__cardView ${isFlipped ? 'flipped' : ''}`}>
                        {/* Лицевая сторона */}
                        <div className="cardPage__cardViewFront" style={{ backgroundImage: `url(${resources.images.bgCard})` }}>
                            <div>
                                <div className="cardPage__cardViewName appearanceAnimation">{userData.user_telegram_name}</div>
                                <div className="cardPage__cardViewNumWrp">
                                    <div onClick={copyCardNum} className="cardPage__cardViewNum appearanceAnimation">
                                        {formatCardNumber(userData.user_card_number)}
                                    </div>
                                    <div
                                        className="cardPage__cardViewNumEye"
                                        style={{
                                            backgroundImage: `url(${
                                                isCardNumberVisible ? resources.icons.eyeClose : resources.icons.eyeOpen
                                            })`
                                        }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            toggleCardNumberVisibility();
                                        }}
                                    ></div>
                                </div>
                            </div>
                            <div className="cardPage__cardViewDate appearanceAnimation">
                                {formatCardDate(userData.user_card_expire)}
                            </div>
                        </div>
                        {/* Обратная сторона */}
                        <div className="cardPage__cardViewBack">
                            <div
                                className="cardPage__cardViewBackBg"
                                style={{ backgroundImage: `url(${resources.images.bgCard})` }}
                            ></div>
                            <div className="cardPage__cardViewCVV appearanceAnimation">
                                {userData.user_card_cvv || '---'}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="cardPage__balanceBlock">
                    <div className="cardPage__balanceBlockInfo">
                        <div className="cardPage__balanceBlockIcon">
                            <img src={resources.images.cardMini} alt="" />
                        </div>
                        <div className="cardPage__balanceBlockValues">
                            <div className="cardPage__balanceBlockText appearanceAnimation">Credit card balance</div>
                            <div className="cardPage__balanceBlockBalance">
                                <div className='cardPage__valueIcon'>
                                    <img style={{ display: 'flex' }} src={resources.icons.dollar} />
                                </div>
                                <div className="cardPage__balanceBlockBalanceValue appearanceAnimation">
                                    {formatNumber(userData.user_card_balance)}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="cardPage__balanceBlockBtns">
                        <button onClick={openDepModal} className="cardPage__balanceBtnDeposit" style={{ backgroundImage: `url(${resources.icons.dep})` }}>Deposit</button>
                        <button onClick={openTransferModal} className="cardPage__balanceBtnTransfer" style={{ backgroundImage: `url(${resources.icons.transfer})` }}>Transfer</button>
                    </div>
                </div>
            </div>
            <Navigation />
            <ModalWindow title={modalTitle} content={modalContent === 'dep' ? <Deposit /> : <Transfer />} />
        </div>
    );
};

export default CardPage;